var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{ref:"dataFile",attrs:{"type":"file"},on:{"change":function($event){return _vm.readWorkbookFromLocalFile($event)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }